import React, {createContext, useContext, useReducer} from 'react';

// Definition the actions
export const DOSSIER_ACTIONS = {
    UPDATE_ALL: 'UPDATE_ALL',
    UPDATE_TAXRETURN: 'UPDATE_TAXRETURN',
    UPDATE_STRUCTURE_DATA: 'UPDATE_STRUCTURE_DATA'
};

// Creation of the context with a more complete default value
const DossierContext = createContext(null);
// Update of tje auth data with dispatch
const DossierDispatchContext = createContext(null);

// Provider of the context that will share the dispatch function
export function DossierProvider({ defaultDossier, children }) {
    const [dossier, dispatch] = useReducer(dossierReducer, defaultDossier ? defaultDossier : {});

    return (
        <DossierContext.Provider value={dossier}>
            <DossierDispatchContext.Provider value={dispatch}>
                {children}
            </DossierDispatchContext.Provider>
        </DossierContext.Provider>
    );
};


function dossierReducer(dossier, action) {
    switch (action.type) {
        case DOSSIER_ACTIONS.UPDATE_ALL: {
            return action.payload;
        }
        case DOSSIER_ACTIONS.UPDATE_TAXRETURN: {
            return { 
                ...dossier,
                tax_return: action.payload
            }
        }
        case DOSSIER_ACTIONS.UPDATE_STRUCTURE_DATA: {
            const { structure_data } = action.payload;
            const { structure_datas = [] } = dossier;

            const existingIndex = structure_datas.findIndex(
                (item) => item.id === structure_data.id
            );

            let updatedStructureDatas;

            if (existingIndex !== -1) {
                // Update existing structure data
                updatedStructureDatas = [...structure_datas];

                updatedStructureDatas[existingIndex] = {
                    ...updatedStructureDatas[existingIndex],
                    ...structure_data,
                };
            } else {
                // Add new structure_data
                updatedStructureDatas = [...structure_datas, structure_data];
            }

            return {
                ...dossier,
                structure_datas: updatedStructureDatas,
            };
        }
        default:
            return dossier;
    }
}

// Creation of a hook to use the context in a component
export function useDossier() {
    return useContext(DossierContext);
};

// Creation of a hook to use the context in a component
export function useDossierDispatch() {
    return useContext(DossierDispatchContext);
};